import { useWindowSize } from '@vueuse/core'

export function useDevice() {
  const { width } = useWindowSize()

  const isMobile = computed(() => width.value < 768)

  const deviceType = computed(() => isMobile.value ? 'mobile' : 'pc')

  return {
    width,
    isMobile,
    deviceType
  }
}